import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Menu,
    Chip,
    Box,
    Divider,
} from '@mui/material';
import { CreateFilter, Filter } from '../Common';

const ReportFilterList = ({
    filters,
    filterValues,
    setFilterListOptions,
    selectedFilter,
    setSelectedFilter,
    filterProps,
}) => {
    const filterBoxWidth = selectedFilter && selectedFilter.type === "date" ? 400 : 300;
    const [filterListAnchor, setFilterListAnchor] = useState(null);
    const [filterOptionAnchor, setFilterOptionAnchor] = useState(null);

    const menuStyle = {
        width: filterBoxWidth,
        height: 'auto',
        maxHeight: '50vh',
    };

    const addFilter = (newFilter, e) => {
        setSelectedFilter(newFilter);
        setFilterListAnchor(null);
        setFilterOptionAnchor(e || filterListAnchor);
    };

    const applyFilter = (value, passedFilterObject = {}) => {
        setFilterListAnchor(null);
        setFilterOptionAnchor(null);
        
        let filter = { value };

        if (!selectedFilter) {
            filter = {
                ...filter,
                property: passedFilterObject.property,
                name: passedFilterObject.name,
                type: passedFilterObject.type,
            };
        } else {
            filter = {
                ...filter,
                property: selectedFilter.property,
                name: selectedFilter.name,
                type: selectedFilter.type,
            };
        }
 
        setFilterListOptions(prev => (
            prev.map(f => {
                if (f.property === filter.property) {
                    let value;
        
                    if (filter.value === null || filter.value === '') {
                        value = f.initialValue;
                    } 
                    else if (Array.isArray(filter.value)) {
                        value = filter.value.length > 1 ? filter.value.filter(item => item.value !== "0") : filter.value;
                    } 
                    else if (typeof filter.value === 'string') {
                        value = filter.value;
                    } 
                    else {
                        value = [filter.value];
                    }
        
                    return {
                        ...f,
                        value
                    };
                }
                return f;
            })
        ));

        setSelectedFilter(null);
    };
    const getFilterValue = (filter) => {
        if (filter.value && Array.isArray(filter.value) && filter.value.length > 0) {
          return filter.value.map(item => item.name).join(filter.property === 'assetTypes' ? ' and ' : ', ');
        }
        return filter.value;
    };

    return (
        <>
            {filters.map(filter => (
                <Box style={{ marginBottom: '4px' }}>
                    <Filter
                        property={filter.property}
                        name={filter.name}
                        value={getFilterValue(filter)}
                        closeFilter={() => {}}
                        onClick={(e) => {
                            addFilter(filter, e.currentTarget);
                        }}
                        required={filter.required}
                    />
                </Box>
            ))}

            <Menu
                anchorEl={filterOptionAnchor}
                open={Boolean(filterOptionAnchor)}
                PaperProps={{ style: {
                    ...menuStyle,
                    overflow: 'visible'
                } }}
                onClose={() => { setFilterOptionAnchor(null);}}
            >
                {(selectedFilter !== null) && (
                    <Box sx={{ p: 2, width: filterBoxWidth }}>
                        <CreateFilter
                            property={selectedFilter.property}
                            type={selectedFilter.type}
                            applyFunction={applyFilter}
                            filterValues={filterValues.filter(f => f.value && f.property === selectedFilter.property)}
                            name={selectedFilter.name}
                            filterProps={selectedFilter.filterProps}
                            disableDatePickerPortal={true}
                            isFilterObject={true}
                            style={selectedFilter.style}
                            initialValue={selectedFilter.value}
                        />
                    </Box>
                )}
            </Menu>
            
        </>
    );
};

ReportFilterList.propTypes = {
    filters: PropTypes.array.isRequired,
    filterValues: PropTypes.array.isRequired,
    setFilterListOptions: PropTypes.func.isRequired,
    selectedFilter: PropTypes.object.isRequired,
    setSelectedFilter: PropTypes.func.isRequired,
    filterProps: PropTypes.object,
};

ReportFilterList.defaultProps = {
    filterProps: { dateAllowFuture: false },
};

export default ReportFilterList;
